module.exports = __webpack_public_path__ + "img/stockPick.064dca3c.png";